import styled from 'styled-components';
import { Link as RRLinkUnstyled } from 'react-router-dom';
import color from 'tinycolor2';

export const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;

  i { /* chevron icon */
    color: ${(props) => color(props.theme['color.text.body']).setAlpha(0.4).toString()};
    margin: 0 4px;
  }
`;

export const RRLink = styled(RRLinkUnstyled)`
  line-height: 24px;
  color: ${(props) => props.theme['color.text.light']};
  font-size: 20px;
  text-decoration: none;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &:hover {
    color: ${(props) => props.theme['color.text.body']};
  }
`;
